import type { OverviewEchoContext } from '@/types/widget';

export const ECHO_STORAGE_KEY = 'calebasse_chat_echo';

/**
 * Read the overview echo (if any) from sessionStorage and clear it.
 * Single-use: subsequent calls return null until the overview widget
 * writes a fresh value.
 */
export function readAndClearEcho(): OverviewEchoContext | null {
  let parsed: OverviewEchoContext | null = null;
  try {
    const raw = sessionStorage.getItem(ECHO_STORAGE_KEY);
    if (raw) {
      parsed = JSON.parse(raw) as OverviewEchoContext;
    }
  } catch {
    parsed = null;
  } finally {
    try {
      sessionStorage.removeItem(ECHO_STORAGE_KEY);
    } catch {
      // ignore
    }
  }
  return parsed;
}
